export default "__VITE_ASSET__DLsJxhvF__"